"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var FileInputField_1 = require("../../../../widgets/FileInputField");
var CollapsibleMessage_1 = __importDefault(require("../../../../../app/components/CollapsibleMessage"));
var types_1 = require("../../../../../app/components/CollapsibleMessage/types");
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var Tooltip_1 = __importDefault(require("../../../../widgets/Tooltip"));
var shortlink_1 = __importDefault(require("../util/shortlink"));
var index_1 = require("../../index");
var url_1 = require("../../../../../app/util/url");
var constants_1 = require("../../../../../../shared/constants");
var format_1 = require("../../../../../app/util/format");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        fileInputField: (_a = {
                marginBottom: theme.spacing(3)
            },
            _a[theme.breakpoints.up('md')] = {
                marginBottom: 0,
            },
            _a),
        regularText: {
            fontWeight: 400,
        },
        originalFileLabel: {
            marginBottom: theme.spacing(1),
        },
    });
});
function FileEditor() {
    var classes = useStyles();
    var drawerStates = (0, index_1.useDrawerState)();
    var _a = (0, shortlink_1.default)(drawerStates.relevantShortLink), shortLinkDispatch = _a.shortLinkDispatch, shortLinkState = _a.shortLinkState, isUploading = _a.isUploading;
    var _b = __read((0, react_1.useState)(null), 2), uploadFileError = _b[0], setUploadFileError = _b[1];
    var originalLongUrl = (0, url_1.removeHttpsProtocol)((shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.longUrl) || '');
    var replaceFileHelp = (react_1.default.createElement("div", { className: classes.originalFileLabel },
        "Original file",
        ' ',
        react_1.default.createElement(Tooltip_1.default, { title: "Original file will be replaced after you select file. Maximum file size is ".concat((0, format_1.formatBytes)(constants_1.MAX_FILE_UPLOAD_SIZE), "."), imageAltText: "Replace file help" })));
    return (react_1.default.createElement(ConfigOption_1.default, { title: replaceFileHelp, leading: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(FileInputField_1.FileInputField, { className: classes.fileInputField, uploadFileError: uploadFileError, textFieldHeight: "44px", fileNameText: originalLongUrl, buttonText: "Replace file", isUploading: isUploading, setFile: function (newFile) {
                    shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.replaceFile(newFile, setUploadFileError);
                }, setUploadFileError: setUploadFileError, maxSize: constants_1.MAX_FILE_UPLOAD_SIZE }),
            react_1.default.createElement(CollapsibleMessage_1.default, { type: types_1.CollapsibleMessageType.Error, visible: !!uploadFileError, position: types_1.CollapsibleMessagePosition.Absolute }, uploadFileError)), trailingPosition: ConfigOption_1.TrailingPosition.none }));
}
exports.default = FileEditor;
